module.exports = {
  channels: {
    APP_INFO: 'app_info',
  },
};